<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>内容管理</p>
    </div>
    <div class="panel-content center_content">
      <div class="course_info">
        <div class="panel-title">
          <p v-if="lessonInfo">{{ lessonInfo ? lessonInfo.title : '' }}</p>
          <p v-if="lessonInfo">负责人:{{  lessonInfo.manager &&  lessonInfo.manager ? lessonInfo.manager.name : '' }}</p>
        </div>
        <div class="course_btn">
          <!-- <router-link
            tag="div"
            :to="'/www/lesson_detail?id=' + lessonInfo.id"
            class="add-btn preview"
          >预览</router-link> -->
          <!-- <div
            v-if="lessonInfo.status==0"
            class="add-btn"
            @click="$parent.saveOnline(lessonInfo.title, lessonInfo.id)"
          >提交审核</div> -->
        </div>
      </div>

      <div id="list">
        <div class="notice_info">
          <div class="notice_title">
            <div>
              <p>预习内容</p>
            </div>
            <div class="handle_btn">
              <div
                class="add-btn"
                style="margin-bottom:0;"
                @click="showStudyWindow(0)"
              >添加预习资源</div>
              <div
                class="add-btn"
                style="margin-bottom:0;"
                @click="showExperimentWindow(0)"
              >添加实验资源</div>
            </div>
          </div>

          <div class="notice_content">
            <div
              class="resource-row"
              v-for="(item, index) in previewStudy"
              :key="index"
            >
              <div class="resource-title">
                {{ item.studyType == 0 ? item.title : item.experiment.title }}
              </div>
              <div class="resource-btn">

                <a
                  href="javascript:;"
                  class="edit"
                  style="text-decoration: none;"
                  @click="moveStudy('preview', index, 'up')"
                  v-if="item.status == 0 && index > 0"
                >上移</a>
                <a
                  href="javascript:;"
                  class="edit"
                  style="text-decoration: none;"
                  @click="moveStudy('preview', index, 'down')"
                  v-if="item.status == 0 && index < previewStudy.length - 1"
                >下移</a>
                <a
                  href="javascript:;"
                  class="edit"
                  style="text-decoration: none;"
                  @click="editStudy(item)"
                  v-if="item.status == 0"
                >编辑</a>
                <a
                  href="javascript:;"
                  class="delete"
                  style="text-decoration: none;"
                  @click="delStudy(item)"
                  v-if="item.status == 0"
                >删除</a>
                <a
                  href="javascript:;"
                  :style="item.status == 1 ? 'color:gray;' : 'color:green'"
                  @click="pubStudy(item)"
                >{{item.status == 1 ? '取消发布' : '发布'}}</a>
              </div>
            </div>
          </div>
        </div>
        <div class="notice_info">
          <div class="notice_title">
            <div>
              <p>学习内容</p>
            </div>
            <div class="handle_btn">
              <div
                class="add-btn"
                style="margin-bottom:0;"
                @click="showStudyWindow(1)"
              >添加学习资源</div>
              <div
                class="add-btn"
                style="margin-bottom:0;"
                @click="showExperimentWindow(1)"
              >添加实验资源</div>
            </div>
          </div>

          <div class="notice_content">
            <div
              class="resource-row"
              v-for="(item, index) in normalStudy"
              :key="index"
            >
              <div class="resource-title">
                {{ item.studyType == 0 ? item.title : item.experiment.title }}
              </div>
              <div class="resource-btn">
                <a
                  href="javascript:;"
                  class="edit"
                  style="text-decoration: none;"
                  @click="moveStudy('normal', index, 'up')"
                  v-if="item.status == 0 && index > 0"
                >上移</a>
                <a
                  href="javascript:;"
                  class="edit"
                  style="text-decoration: none;"
                  @click="moveStudy('normal', index, 'down')"
                  v-if="item.status == 0 && index < normalStudy.length - 1"
                >下移</a>
                <a
                  href="javascript:;"
                  class="edit"
                  style="text-decoration: none;"
                  @click="editStudy(item)"
                  v-if="item.status == 0"
                >编辑</a>
                <a
                  href="javascript:;"
                  class="delete"
                  style="text-decoration: none;"
                  @click="delStudy(item)"
                  v-if="item.status == 0"
                >删除</a>
                <a
                  href="javascript:;"
                  :style="item.status == 1 ? 'color:gray;' : 'color:green'"
                  @click="pubStudy(item)"
                >{{item.status == 1 ? '取消发布' : '发布'}}</a>
              </div>
            </div>
          </div>
        </div>
        <div class="notice_info">
          <div class="notice_title">
            <div>
              <p>测试</p>
            </div>
            <div class="handle_btn">
              <div
                class="add-btn"
                style="margin-bottom:0;"
                @click="showExamWindow"
              >添加测试</div>
            </div>
          </div>
          <div class="notice_content">
            <div
              class="resource-row"
              v-for="(item, index) in examData"
              :key="index"
            >
              <div class="resource-title">
                {{ item.title }}
              </div>
              <div class="resource-btn">
                <a
                  href="javascript:;"
                  class="status_1"
                  style="text-decoration: none;"
                  @click="maintainExam(item)"
                  v-if="item.status == 0"
                >维护</a>
                <a
                  href="javascript:;"
                  class="edit"
                  style="text-decoration: none;"
                  @click="editExam(item)"
                  v-if="item.status == 0"
                >编辑</a>
                <a
                  href="javascript:;"
                  class="delete"
                  style="text-decoration: none;"
                  @click="delExam(item)"
                  v-if="item.status == 0"
                >删除</a>
                <a
                  href="javascript:;"
                  :style="item.status == 1 ? 'color:gray;' : 'color:green'"
                  @click="pubExam(item)"
                >{{item.status == 1 ? '取消发布' : '发布'}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--添加资源-->
    <div
      class="form_overlay"
      style="z-index: 2;"
      :style="classShowStudyWindow"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_title">普通资源</div>
        <div class="form_content">
          <form id="itemForm">
            <div class="item">
              <span class="label"><i class="require">*</i>资源文件:</span>
              <input
                type="text"
                style="width: 225px;margin-top: -4px;"
                disabled
                v-model="studyInfo.path"
                autocomplete="off"
              >
              <span
                class="button file up"
                style="display: inline-block"
                @click="showFileWindow"
              >上传文件</span>
            </div>
            <div class="item">
              <span class="label"><i class="require">*</i>资源名称:</span>
              <input
                type="text"
                v-model="studyInfo.title"
                autocomplete="off"
                maxlength="20"
              >
            </div>
            <div class="item">
              <span class="label"><i class="require">*</i>资源作者:</span>
              <input
                type="text"
                v-model="studyInfo.author"
                autocomplete="off"
                maxlength="10"
              >
            </div>
            <div class="item">
              <span class="label"><i class="require">*</i>作者单位:</span>
              <input
                type="text"
                v-model="studyInfo.org"
                autocomplete="off"
                maxlength="25"
              >
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            class="button close"
            id="form_close"
            @click="hideStudyWindow"
          >取消</a>
          <a
            href="javascript:;"
            class="button"
            id="form_submit"
            @click="saveResourceStudy"
          >提交</a>
        </div>
      </div>
    </div>
    <!-- 上传文件 -->
    <div
      id="file-upload-overlay"
      :style="showWindow.bigFile ? 'display: block' : ''"
    >
      <div class="file-upload-bg"></div>
      <div class="file-upload">
        <div class="file-upload-type">允许上传的文件扩展名：jpg,png,mp4,mp3,pdf,doc,docx</div>
        <div
          class="file-upload-close"
          @click="hideFileWindow"
        >×</div>
        <span
          class="file_uploadBtn"
          id="file_uploadBtn"
          style="display: block;"
        >
          选择文件<input
            type="file"
            id="file_fileInput"
            ref="docFile"
            style="display: block;"
            accept=".jpg,.png,.mp4,.mp3,.pdf,.doc,.docx"
            @change="fileChange"
          >
        </span>
        <div
          class="fileBox"
          id="file_uploadBox"
          style="display: block;"
        >
          <span
            class="pauseBtn"
            id="file_pauseBtn"
            style="display: none;"
          >暂停</span>
          <span
            class="goBtn"
            id="file_goBtn"
            style="display:none;"
          >继续</span>
          <div
            class="filename"
            id="file_filename"
            style="display: none;"
          ></div>
          <div
            class="pbar"
            :style="showWindow.bigFileOption.showProgress ? 'display: block' : 'display: none'"
          >
            <div
              class="progress"
              id="file_progress"
              :style="'width: ' + Math.ceil(showWindow.bigFileOption.progressValue * 4.2) + 'px;'"
            ></div>
            <div id="file_percent">{{ showWindow.bigFileOption.progressValue }}%</div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
    <!-- 实验弹窗 -->
    <div
      id="c-panel"
      :style="classShowExperimentWindow"
    >
      <div id="c-panel-bg"></div>
      <div
        class="c-content"
        style="width:830px"
      >
        <form
          id="search"
          onsubmit="return false;"
          style="width:830px"
        >
          <input
            type="text"
            class="s-text"
            v-model="resourcesInfo.title"
            placeholder="实验名称"
            autocomplete="off"
          >
          <input
            type="submit"
            class="s-btn1"
            @click="resourcesInfo.page = 1,getResources()"
            value="查询"
          >
          <span
            class="close-cpanel"
            @click="hideExperimentWindow"
          ></span>
        </form>
        <ul
          id="uList"
          class="clearfix expList"
        >
          <li
            v-for="(item, index) in resourcesData"
            :key="index"
          >
            <div class="cover">
              <img
                :src="item.logo"
                class="project-img check-img"
                :onerror="$store.state.defaultImg"
              >
            </div>
            <div class="info">
              <div class="project-title">
                <a>{{item.title}}</a>
              </div>
              <div
                class="project-brief"
                :title="item.master_name ? item.master_name : ''"
              >负责人：{{ item.master_name ? item.master_name : '-' }}</div>
              <span
                v-if="!checkExperimentExist(item)"
                class="no"
                @click="saveExperimentStudy(item)"
              >选择</span>
              <span
                class="yes"
                v-else
              >已选择</span>
            </div>
          </li>
        </ul>
        <!-- 分页 -->
        <pagination
          :cur='resourcePager.page'
          :all='resourcePager.all'
          :totalData="resourcePager.totalData"
          :callback="pageResource"
        ></pagination>
      </div>
    </div>
    <!-- 新增测试 -->
    <div
      class="form_overlay"
      :style="classShowExamWindow"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_title">测试管理</div>
        <div class="form_content">
          <form>
            <div class="item">
              <span class="label"><i class="require">*</i>测试标题:</span>
              <input
                type="text"
                v-model="formExam.title"
                autocomplete="off"
                maxlength="20"
              >
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            class="button close"
            @click="hideExamWindow"
          >取消</a>
          <a
            href="javascript:;"
            class="button"
            @click="saveExam"
          >提交</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '../../../components/Pager'

export default {
  name: 'OnlineContent',
  components: {
    Pagination
  },
  props: [
    'lessonInfo'
  ],
  data() {
    return {
      classShowStudyWindow: {}, // 学习及实验
      classShowExperimentWindow: {
        display: 'none'
      }, // 实验数据
      classShowExamWindow: {
        visibility: 'hidden'
      },
      showWindow: {
        bigFile: false,
        bigFileOption: {
          showProgress: false,
          progressValue: 0
        }
      },
      studyInfo: {
        id: 0,
        lessonOnline_id: this.lessonInfo.id,
        preview: null,
        studyType: 0,
        sortNum: null,

        path: null,
        title: null,
        author: null,
        org: null
      },
      expStudyInfo: {
        id: 0,
        lessonOnline_id: this.lessonInfo.id,
        preview: null,
        studyType: 1,
        sortNum: null,

        experiment_id: null
      },
      resourcesInfo: { // 资源查询条件
        title: '',
        status: 9,
        page: 1,
        size: 10
      },
      resourcesData: [], // 资源数据
      resourcesCount: 0,
      studyData: [],
      formExam: {
        id: null,
        lessonOnline_id: this.lessonInfo.id,
        title: ''
      },
      examData: []
    }
  },
  methods: {
    // 添加理论学习及实验弹窗
    showStudyWindow(preview) {
      this.studyInfo.preview = preview
      this.classShowStudyWindow = {
        visibility: 'visible'
      }
    },
    hideStudyWindow() {
      this.classShowStudyWindow = {}
      this.studyInfo = {
        id: 0,
        lessonOnline_id: this.lessonInfo.id,
        preview: null,
        studyType: 0,
        sortNum: null,

        path: null,
        title: null,
        author: null,
        org: null
      }
    },
    // 上传文件
    showFileWindow() {
      this.showWindow.bigFile = true
    },
    hideFileWindow() {
      this.showWindow.bigFile = false
    },
    async fileChange() {
      this.showWindow.bigFileOption.showProgress = true
      const fileRealName = this.$refs.docFile.files[0].name
      const uploadUrl = '/info_files/' + fileRealName
      await this.$http.put(uploadUrl, this.$refs.docFile.files[0], {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (e) => {
          this.showWindow.bigFileOption.progressValue = Math.ceil(e.loaded / e.total * 100)
        }
      }).then((data) => {
        this.showWindow.bigFileOption.showProgress = false
        this.showWindow.bigFileOption.progressValue = 0
        this.hideFileWindow()

        this.studyInfo.path = data
      }).catch(() => {
        this.showWindow.bigFileOption.showProgress = false
        this.showWindow.bigFileOption.progressValue = 0
        this.hideFileWindow()
        this.$layer.msg('上传失败！')
      })
    },
    // 实验弹窗
    showExperimentWindow(preview) {
      this.resourcesData = []
      this.resourcesCount = 0
      this.resourcesInfo.page = 1
      this.resourcesInfo.title = ''
      this.getResources()
      this.expStudyInfo.preview = preview
      this.classShowExperimentWindow = {
        display: 'block'
      }
    },
    hideExperimentWindow() {
      this.classShowExperimentWindow = {
        display: 'none'
      }
      this.expStudyInfo = {
        id: 0,
        lessonOnline_id: this.lessonInfo.id,
        preview: null,
        studyType: 1,
        sortNum: null,

        experiment_id: null
      }
    },
    async getResources() {
      await this.$http.get('/experiment_list/', {
        params: this.resourcesInfo
      }).then((data) => {
        if (data.code === '200') {
          this.resourcesData = data.data.results
          this.resourcesCount = data.data.count
        } else {
          this.$layer.msg('获取实验信息失败！')
        }
      }).catch(() => {
        this.$layer.msg('获取实验列表失败！')
      })
    },
    pageResource(data) {
      this.resourcesInfo.page = data
      this.getResources()
    },
    // 保存
    async saveResourceStudy() {
      if (!this.studyInfo.path) {
        this.$layer.msg('请上传资源文件')
        return
      } else if (!this.studyInfo.title) {
        this.$layer.msg('请填写资源名称')
        return
      } else if (!this.studyInfo.author) {
        this.$layer.msg('请填写资源作者')
        return
      } else if (!this.studyInfo.org) {
        this.$layer.msg('请填写作者单位')
        return
      }
      const allExp = ['jpg', 'png', 'mp4', 'mp3', 'ppt', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'csv']
      const expName = this.studyInfo.path.substring(this.studyInfo.path.lastIndexOf('.') + 1, this.studyInfo.path.length)
      if (allExp.indexOf(expName) < 0) {
        this.$layer.msg('允许上传的文件扩展名：jpg,png,mp4,mp3,ppt,pdf,doc,docx,xls,xlsx,csv')
        return
      }
      if (this.studyInfo.id) {
        await this.$http.put('/online_study/' + this.studyInfo.id + '/', this.studyInfo).then((data) => {
          if (data.id) {
            this.hideStudyWindow()
            this.searchStudy()
            this.$parent.showMsg('修改成功！')
          } else {
            this.$parent.$parent.showMsg('修改失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('修改失败！')
        })
      } else {
        const data = await this.$http.get('/online_study_max_sortnum/', {
          params: {
            id: this.lessonInfo.id
          }
        })
        this.studyInfo.sortNum = data.data + 1
        await this.$http.post('/online_study/', this.studyInfo).then((data) => {
          if (data.id) {
            this.hideStudyWindow()
            this.searchStudy()
            this.$parent.showMsg('添加成功！')
          } else {
            this.$parent.showMsg('添加失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('添加失败！')
        })
      }
    },
    async saveExperimentStudy(item) {
      this.expStudyInfo.experiment_id = item.id
      if (this.expStudyInfo.id) {
        await this.$http.put('/online_study/' + this.expStudyInfo.id + '/', this.expStudyInfo).then((data) => {
          if (data.id) {
            this.hideExperimentWindow()
            this.searchStudy()
            this.$parent.showMsg('修改成功！')
          } else {
            this.$parent.$parent.showMsg('修改失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('修改失败！')
        })
      } else {
        const data = await this.$http.get('/online_study_max_sortnum/', {
          params: {
            id: this.lessonInfo.id
          }
        })
        this.expStudyInfo.sortNum = data.data + 1
        await this.$http.post('/online_study/', this.expStudyInfo).then((data) => {
          if (data.id) {
            this.hideExperimentWindow()
            this.searchStudy()
            this.$parent.showMsg('添加成功！')
          } else {
            this.$parent.showMsg('添加失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('添加失败！')
        })
      }
    },
    // 搜索
    async searchStudy () {
      await this.$http.get('/online_study/', {
        params: {
          page: 1,
          size: 10000,
          lessonOnline_id: this.lessonInfo.id
        }
      }).then((data) => {
        this.studyData = data.results
      }).catch((error) => {
        console.log(error)
      })
    },
    editStudy (item) {
      if (item.studyType === 0) {
        this.studyInfo = {
          id: item.id,
          lessonOnline_id: this.lessonInfo.id,
          preview: item.preview,
          studyType: 0,
          sortNum: item.sortNum,

          path: item.path,
          title: item.title,
          author: item.author,
          org: item.org
        }
        this.classShowStudyWindow = {
          visibility: 'visible'
        }
      } else if (item.studyType === 1) {
        this.resourcesData = []
        this.resourcesCount = 0
        this.getResources()

        this.expStudyInfo = {
          id: item.id,
          lessonOnline_id: item.lessonOnline_id,
          preview: item.preview,
          studyType: 1,
          sortNum: item.sortNum,
          experiment_id: item.experiment_id
        }
        this.classShowExperimentWindow = {
          display: 'block'
        }
      }
    },
    delStudy (item) {
      this.$parent.showConfirm('确定要删除吗？', async () => {
        await this.$http.put('/online_study/' + item.id + '/', {
          isdel: 1
        }).then((data) => {
          this.searchStudy()
        }).catch((error) => {
          console.log(error)
        })
      })
    },
    pubStudy (item) {
      this.$parent.showConfirm('确定要' + (item.status === 0 ? '' : '取消') + '发布吗？', async () => {
        await this.$http.put('/online_study/' + item.id + '/', {
          status: 1 - item.status
        }).then((data) => {
          this.searchStudy()
        }).catch((error) => {
          console.log(error)
        })
      })
    },
    // 测试
    showExamWindow() {
      this.formExam.id = null
      this.formExam.title = ''
      this.classShowExamWindow = {
        visibility: 'visible'
      }
    },
    hideExamWindow() {
      this.classShowExamWindow = {
        visibility: 'hidden'
      }
    },
    async saveExam() {
      if (!this.formExam.title) {
        this.$parent.showMsg('请输入测试标题！')
        return
      }
      if (this.formExam.id) {
        await this.$http.put('/online_exam/' + this.formExam.id + '/', this.formExam).then((data) => {
          if (data.id) {
            this.searchExam()
            this.hideExamWindow()
          }
        }).catch(() => {
          this.$layer.msg('修改测试失败！')
        })
      } else {
        const exams = await this.$http.get('/online_exam/', {
          params: {
            page: 1,
            size: 10000,
            lessonOnline_id: this.lessonInfo.id
          }
        })
        if (exams.results.length > 0) {
          this.$parent.showMsg('每个课程只能有一个测试！')
          return
        }
        await this.$http.post('/online_exam/', this.formExam).then((data) => {
          if (data.id) {
            this.searchExam()
            this.hideExamWindow()
          }
        }).catch(() => {
          this.$layer.msg('添加测试失败！')
        })
      }
    },
    editExam (item) {
      this.formExam.id = item.id
      this.formExam.title = item.title
      this.classShowExamWindow = {
        visibility: 'visible'
      }
    },
    async searchExam () {
      await this.$http.get('/online_exam/', {
        params: {
          page: 1,
          size: 10000,
          lessonOnline_id: this.lessonInfo.id
        }
      }).then((data) => {
        this.examData = data.results
      }).catch((error) => {
        console.log(error)
      })
    },
    delExam (item) {
      this.$parent.showConfirm('确定要删除吗？', async () => {
        await this.$http.put('/online_exam/' + item.id + '/', {
          isdel: 1
        }).then((data) => {
          this.searchExam()
        }).catch((error) => {
          console.log(error)
        })
      })
    },
    pubExam (item) {
      this.$parent.showConfirm('确定要' + (item.status === 0 ? '' : '取消') + '发布吗？', async () => {
        await this.$http.put('/online_exam/' + item.id + '/', {
          status: 1 - item.status
        }).then((data) => {
          this.searchExam()
        }).catch((error) => {
          console.log(error)
        })
      })
    },
    maintainExam (item) {
      this.$router.push('/online/content/exam?id=' + this.lessonInfo.id + '&exam_id=' + item.id)
    },
    async moveStudy (preview, index, category) {
      let data1 = null
      let data2 = null
      if (preview === 'preview') {
        data1 = this.previewStudy[index]
        if (category === 'up') {
          data2 = this.previewStudy[index - 1]
        } else if (category === 'down') {
          data2 = this.previewStudy[index + 1]
        }
      }
      if (preview === 'normal') {
        data1 = this.normalStudy[index]
        if (category === 'up') {
          data2 = this.normalStudy[index - 1]
        } else if (category === 'down') {
          data2 = this.normalStudy[index + 1]
        }
      }
      await this.$http.post('/online_study_change_sortnum/', {
        id_1: data1.id,
        sn_1: data1.sortNum,
        id_2: data2.id,
        sn_2: data2.sortNum
      }).then((data) => {
        if (data.code === '200') {
          this.searchStudy()
          this.$layer.msg('操作成功！')
        } else {
          this.$layer.msg('操作失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('操作失败！')
      })
    },
    checkExperimentExist (item) {
      for (let i = 0; i < this.studyData.length; i++) {
        if (this.studyData[i].experiment_id === item.id) {
          return true
        }
      }
      return false
    }
  },
  mounted() {
    this.searchStudy()
    this.searchExam()
  },
  computed: {
    resourcePager () {
      return {
        page: this.resourcesInfo.page,
        all: Math.ceil(this.resourcesCount / this.resourcesInfo.size),
        totalData: this.resourcesCount
      }
    },
    previewStudy () {
      return this.studyData.filter(m => {
        return m.preview === 0
      })
    },
    normalStudy () {
      return this.studyData.filter(m => {
        return m.preview === 1
      })
    }
  }
}
</script>

<style scoped src="@/assets/css/project-detail.css"></style>
<style scoped src="@/assets/css/chunkUpload.css"></style>

<style lang="less" scoped>
.panel-content {
  padding: 20px 40px;
}
.c-content {
  margin: 0;
  transform: translate(-50%, -50%);
}
.itemStatus {
  img {
    width: 120px;
  }
}
#c-panel {
  z-index: 2;
}
.c-content {
  min-height: 650px;
}
.active {
  color: #266dc7 !important;
  text-decoration: underline;
}
.course_info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  .panel-title {
    p {
      display: inline-block;
      margin-right: 20px;

      &:last-child {
        color: #999;
        font-size: 16px;
      }
    }
  }
  .course_btn {
    div {
      margin-left: 20px;
      padding: 7px 20px;
      background: #73D6CA;
      color: #fff;
      border-radius: 3px;
    }
    .preview {
      border: 1px solid #73D6CA;
      color: #73D6CA;
      background: #fff;
    }
  }
}
.crumb_nav {
  color: #999;
  margin-top: 20px;
}
.add-btn {
  width: unset;
  height: unset;
  line-height: normal;
}
// 公告
.notice_info {
  min-height: 130px;
  margin-bottom: 20px;
  border: 1px solid #eee;
  &:last-child {
    margin-bottom: 0;
  }
  .notice_title {
    //background: #eee;
    padding: 10px 20px;
    font-size: 16px;
    color: #333;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eeeeee;
    p {
      &:last-child {
        font-size: 18px;
        color: #999;
        //margin-top: 10px;
      }
    }
    .handle_btn {
      div {
        margin-left: 20px;
        padding: 7px 20px;
        background: #73D6CA;
        color: #fff;
        border-radius: 3px;
        font-size: 14px;
      }
    }
  }
  .notice_content {
    padding: 0px 20px;
    color: #333;
    .resource-row {
      height: 50px;
      background: #eee;
      margin: 10px 0px;
      .resource-title {
        display: inline-block;
        line-height: 50px;
        margin-left: 15px;
      }
      .resource-btn {
        display: inline-block;
        line-height: 50px;
        float: right;
        margin-right: 15px;
      }
    }
  }
}
.k-container1 {
  float: left;
  max-width: 500px;
}

#c-panel {
  z-index: 2;
  .expList {
    overflow: hidden;
    li {
      float: left;
      width: 380px;
      padding: 10px;
      margin-bottom: 20px;
      margin-right: 20px;
      background-color: #fff;
      border: 1px solid #eee;
      position: relative;
      display: flex;
      .cover {
        width: 134px;
        height: 84px;
        margin-right: 10px;
        position: relative;
        float: left;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .info {
        flex: 1;
        overflow: hidden;
        .project-title {
          a {
            display: inline-block;
            width: 230px;
            font-size: 16px;
            margin-bottom: 5px;
            font-weight: normal;
            color: #000;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .project-brief {
          margin-top: 10px;
          max-width: 170px;
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        span {
          float: right;
          margin-top: 20px;
          width: 44px;
          height: 26px;
          line-height: 26px;
          text-align: center;
          cursor: pointer;
        }
        .no {
          color: #fff;
          background: #4975e7;
        }
        .yes {
          color: #333;
        }
      }
    }
    li:nth-child(2n) {
      margin-right: 0;
    }
  }
}
</style>
